import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import './styles/globals.css';
import { loadDynamicFavicon } from './utils/dynamicFavicon';

// Load dynamic favicon from CMS
loadDynamicFavicon();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);